import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  UpdateSprintInProjectTemplate,
  updateSprintInProjectTemplate,
} from '../../actions';
import { selectTemplateSprint } from '../../selectors';
import { updateProjectTemplateSprint } from '../../slices';
import { ProjectTemplateSprint } from '../../types';

function* updateSprintInTemplateSaga(
  action: StoreActionProps<UpdateSprintInProjectTemplate>,
) {
  try {
    const {
      payload: { sprintId, payload },
    } = action;

    const sprint: ProjectTemplateSprint = yield select(
      selectTemplateSprint(sprintId),
    );

    try {
      const currentFields =
        sprint?.fields && sprint?.fields.length > 0
          ? payload.fields && payload.fields?.length > 0
            ? sprint?.fields?.filter(
                (f) =>
                  !payload.fields?.map((x) => x.fieldId).includes(f.fieldId),
              )
            : sprint.fields
          : [];

      yield put(
        updateProjectTemplateSprint({
          sprint: {
            ...sprint,
            ...payload,
            fields:
              payload?.fields && payload?.fields.length > 0
                ? [...currentFields, ...payload.fields]
                : currentFields,
          },
        }),
      );
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      yield put(
        updateProjectTemplateSprint({
          sprint: {
            ...sprint,
            ...payload,
          },
        }),
      );
    }

    /**
     * Commenting out old date shift logic code
     * TODO: to be removed after thorough code walk through.
     */

    // if (payload.duration || payload.startDay) {
    //   yield put(updateProjectTemplateStartdayDuration({ taskId }));
    // }
  } catch (error) {
    logger.error('updateProjectTemplateSprint failed', { error });

    message.error('There was an error updating the sprint');
  }
}

export function* watchUpdateSprintInProjectTemplateSaga(): Generator {
  yield takeLatest(
    updateSprintInProjectTemplate.type,
    updateSprintInTemplateSaga,
  );
}
